import React, { Component } from "react";
import { Wrapper, Title, Copy, Row, Icon } from "app/NativeComponents/common";

class MoreInfo extends Component {
  render() {
    const { colors, plan_info } = this.props;
    if (plan_info) {
      if (
        plan_info.fields.additionalPlanInfoTitle &&
        plan_info.fields.additionalPlanInfo
      ) {
        return (
          <Wrapper
            style={{
              borderBottomWidth: 1,
              borderBottomStyle: "solid",
              borderBottomColor: colors.border_color,
              paddingBottom: 20,
              paddingTop: 20
            }}
          >
            <Wrapper style={{ padding: 10, flex: 1 }}>
              <Title>{plan_info.fields.additionalPlanInfoTitle}</Title>
            </Wrapper>
            <Wrapper style={{ padding: 20 }}>
              {plan_info.fields.additionalPlanInfo.map((info, i) => {
                return (
                  <Wrapper key={"more_info_" + i} style={{ marginBottom: 10 }}>
                    <Row style={{ alignItems: "flex-start" }}>
                      <Icon
                        fa_icon="circle"
                        size={5}
                        style={{ marginRight: 10, marginTop: 8 }}
                      />
                      <Copy>{info}</Copy>
                    </Row>
                  </Wrapper>
                );
              })}
            </Wrapper>
          </Wrapper>
        );
      }
    }
    return null;
  }
}

export default MoreInfo;
